var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19748_18538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 6.0004H16V4.3304C15.9765 3.69022 15.7002 3.08546 15.2316 2.64869C14.7629 2.21193 14.1402 1.97879 13.5 2.0004H10.5C9.85975 1.97879 9.23706 2.21193 8.76843 2.64869C8.2998 3.08546 8.02346 3.69022 8 4.3304V6.0004H3C2.73478 6.0004 2.48043 6.10576 2.29289 6.2933C2.10536 6.48083 2 6.73519 2 7.0004C2 7.26562 2.10536 7.51997 2.29289 7.70751C2.48043 7.89504 2.73478 8.0004 3 8.0004H4V19.0004C4 19.7961 4.31607 20.5591 4.87868 21.1217C5.44129 21.6843 6.20435 22.0004 7 22.0004H17C17.7956 22.0004 18.5587 21.6843 19.1213 21.1217C19.6839 20.5591 20 19.7961 20 19.0004V8.0004H21C21.2652 8.0004 21.5196 7.89504 21.7071 7.70751C21.8946 7.51997 22 7.26562 22 7.0004C22 6.73519 21.8946 6.48083 21.7071 6.2933C21.5196 6.10576 21.2652 6.0004 21 6.0004ZM10 4.3304C10 4.1704 10.21 4.0004 10.5 4.0004H13.5C13.79 4.0004 14 4.1704 14 4.3304V6.0004H10V4.3304ZM18 19.0004C18 19.2656 17.8946 19.52 17.7071 19.7075C17.5196 19.895 17.2652 20.0004 17 20.0004H7C6.73478 20.0004 6.48043 19.895 6.29289 19.7075C6.10536 19.52 6 19.2656 6 19.0004V8.0004H18V19.0004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17C9.26522 17 9.51957 16.8946 9.70711 16.7071C9.89464 16.5196 10 16.2652 10 16V12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12V16C8 16.2652 8.10536 16.5196 8.29289 16.7071C8.48043 16.8946 8.73478 17 9 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17C15.2652 17 15.5196 16.8946 15.7071 16.7071C15.8946 16.5196 16 16.2652 16 16V12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12V16C14 16.2652 14.1054 16.5196 14.2929 16.7071C14.4804 16.8946 14.7348 17 15 17Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19748_18538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutline);
export default __webpack_public_path__ + "static/media/trashOutline.9fc5a3f6dfc5c9c8e3cdd44808598821.svg";
export { ForwardRef as ReactComponent };